<mat-select [formControl]="kontroll" panelWidth="200px" placeholder="{{'Ikke-standard'|translate}} ({{aktivFont()}})" (opened)="vedMenyAapnet()" (closed)="vedMenyLukket()">
  <mat-select-trigger>
    @if(kontroll.value != null){
      <span [style.font-family]="kontroll.value.family">{{ kontroll.value.navn }}</span>
    }
  </mat-select-trigger>
  @for (font of fonter; track font.font) {
    <mat-option [value]="font"><span [style.font-family]="font.family">{{ font.navn }}</span></mat-option>
  }
</mat-select>
